import { newSpecPage } from '@stencil/core/testing';
import { LabDsTable } from './lab-ds-table';

describe('v4-table', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsTable],
      html: `<lab-ds-table/>`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-table>
      <div class="header-left scroll-customized  v4-table">
        <table>
          <thead>
            <tr class="table-header"></tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </lab-ds-table>
  `);
  });
});
